/* Storchwindeln: Hinweis für Vorbestell-Artikel (Lieferzeit 3–4 Wochen) */
(function(){
  'use strict';
  var PRE_V=[61086441439566,61086441701710,61086441767246,61086456152398,61086456217934,61086456250702];
  var PRE_IDS=['pp3-210','pp6-168','pp5plus-180','ppp5-164','bdp5-180','huggies-extra4-120'];
  var PRE_H=['pampers-baby-dry-pants-groesse-5-180','huggies-extra-care-disney-groesse-4-120','pampers-premium-protection-pants-groesse-5-164','pampers-premium-protection-groesse-5-plus-180','pampers-premium-protection-groesse-6-168','pampers-premium-protection-groesse-3-210'];
  var TXT='3–4 Wochen (Vorbestellung)';
  var NOTE='<b>Hinweis: Vorbestellung im Warenkorb</b><br>Markierte Artikel haben eine Lieferzeit von 3–4 Wochen. Möchten Sie nur sofort lieferbare Artikel (1–3 Werktage) bestellen, entfernen Sie diese Artikel bitte hier.';
  var NS='margin:0 0 12px;padding:12px 14px;border-radius:10px;background:#FFF4E5;border:1px solid #F0C48A;color:#7A4A12;font-size:13px;line-height:1.45';
  var BS='color:#B5562F;font-weight:600;font-size:13px;margin-top:4px';

  function badge(){var d=document.createElement('div');d.className='pre-b';d.style.cssText=BS;d.textContent='Vorbestellung · Lieferzeit 3–4 Wochen';return d}
  function fast(){var d=document.createElement('div');d.className='pre-b';d.style.cssText='color:#3E6B52;font-weight:600;font-size:13px;margin-top:4px';d.textContent='Lieferzeit 1–3 Werktage';return d}
  function note(){var n=document.createElement('div');n.className='pre-note';n.style.cssText=NS;n.innerHTML=NOTE;return n}

  /* Vermerk "Lieferzeit" an Vorbestell-Positionen setzen (erscheint im Checkout und in der Bestellbestätigung) */
  function fix(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      var todo=(c.items||[]).filter(function(it){return PRE_V.indexOf(it.variant_id)>-1&&!(it.properties&&it.properties.Lieferzeit)});
      return todo.reduce(function(p,it){return p.then(function(){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:it.key,quantity:it.quantity,properties:{Lieferzeit:TXT}})})})},Promise.resolve()).then(function(){return todo.length});
    }).catch(function(){return 0});
  }

  /* Warenkorb-Schublade auf der Startseite */
  var L=document.getElementById('lines');
  if(L){
    var obs;
    var paint=function(){
      obs.disconnect();
      var has=false;
      Array.prototype.forEach.call(L.querySelectorAll('[data-rm]'),function(b){
        var isPre=PRE_IDS.indexOf(b.getAttribute('data-rm'))>-1;if(isPre)has=true;if(!b.parentNode.querySelector('.pre-b'))b.parentNode.insertBefore(isPre?badge():fast(),b)
      });
      var n=L.querySelector('.pre-note');
      if(has&&!n)L.insertBefore(note(),L.firstChild);else if(!has&&n)n.parentNode.removeChild(n);
      obs.observe(L,{childList:true,subtree:true});
    };
    obs=new MutationObserver(paint);
    paint();
  }

  /* Warenkorb-Seite /cart */
  var list=document.querySelector('.sc-list');
  if(list){
    var has=false;
    Array.prototype.forEach.call(list.querySelectorAll('.sc-line'),function(line){
      var a=line.querySelector('.sc-t');var href=a?a.getAttribute('href')||'':'';
      var isPre=PRE_H.some(function(h){return href.indexOf('/products/'+h)>-1});if(isPre)has=true;
      var s=line.querySelector('.sc-s');if(s&&!line.querySelector('.pre-b'))s.parentNode.insertBefore(isPre?badge():fast(),s.nextSibling);
    });
    if(has){
      list.insertBefore(note(),list.firstChild);
      var k='pre-fix-'+location.pathname;
      fix().then(function(n){try{if(n&&!sessionStorage.getItem(k)){sessionStorage.setItem(k,'1');location.reload()}}catch(e){}});
    }
  }

  /* Lieferzeit auf Produktkarten (Startseite, Kategorien, Suche) */
  function dl(href){var pre=PRE_H.some(function(h){return href.indexOf('/products/'+h)>-1});var d=document.createElement('div');d.className='dl-t';d.style.cssText='font-size:12px;font-weight:600;margin-top:4px;color:'+(pre?'#B5562F':'#3E6B52');d.textContent=pre?'Lieferzeit 3–4 Wochen (Vorbestellung)':'Lieferzeit 1–3 Werktage';return d}
  function cards(root){
    Array.prototype.forEach.call(root.querySelectorAll('#grid .card, #grid article'),function(c){if(c.querySelector('.dl-t'))return;var a=c.querySelector('a.name[href*="/products/"]');var m=c.querySelector('.meta');if(a&&m)m.appendChild(dl(a.getAttribute('href')))});
    Array.prototype.forEach.call(root.querySelectorAll('a.cl-card[href*="/products/"]'),function(c){if(c.querySelector('.dl-t'))return;c.appendChild(dl(c.getAttribute('href')))});
  }
  var G=document.getElementById('grid');
  if(G){var go;var gp=function(){go.disconnect();cards(document);go.observe(G,{childList:true,subtree:true})};go=new MutationObserver(gp);gp()}
  cards(document);

  /* Vor dem Checkout: Vermerk sicher setzen */
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('#checkout, a[href="/checkout"], button[name="checkout"]');
    if(!t)return;
    var cc=document.getElementById('cartCount');
    if(cc&&cc.textContent.trim()==='0')return;
    e.preventDefault();e.stopImmediatePropagation();
    t.style.opacity=.6;
    setTimeout(function(){fix().then(function(){location.href='/checkout'})},L?1200:0);
  },true);
})();
